import {axiosPrivate} from "../axios-config/axiosPrivate";
import {standardRequestConfig} from "../axios-config/requestConfig";
import {BACKEND} from "../config/backend";

export const getNachrichtListData = ({nachrichtenListParameter}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/nachricht/list`, {
        ...standardRequestConfig
        , params: nachrichtenListParameter
    })
}

export const deleteNachrichtenByMsgIdList = ({nachrichtenIdList}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/nachricht/list`, {
        ...standardRequestConfig
        , params: {nachrichtenIdList}
    })
}